import * as spine from "@esotericsoftware/spine-webgl";

/**
 * 自定义的 AttachmentLoader，支持从多个 TextureAtlas 中查找 Region
 * 
 * 基于 Spine 官方文档：https://esotericsoftware.com/spine-loading-skeleton-data#AttachmentLoader
 * 
 * 用于支持 Spine 资源拆分为多个 Atlas 的场景（如 A.atlas + IDR.atlas）
 */
export class MultiAtlasAttachmentLoader implements spine.AttachmentLoader {
  private atlases: spine.TextureAtlas[];

  constructor(atlases: spine.TextureAtlas[]) {
    this.atlases = atlases;
  }

  /**
   * 从所有 Atlas 中查找 Region
   * 顺序无关，因为每个 Region 名称是唯一的
   */
  private findRegion(path: string): spine.TextureAtlasRegion | null {
    for (const atlas of this.atlases) {
      const region = atlas.findRegion(path);
      if (region) return region;
    }
    return null;
  }

  newRegionAttachment(
    _skin: spine.Skin,
    name: string,
    path: string
  ): spine.RegionAttachment {
    const region = this.findRegion(path);
    if (!region) {
      throw new Error(`Region not found in any atlas: ${path}`);
    }
    const attachment = new spine.RegionAttachment(name, path);
    attachment.region = region;
    return attachment;
  }

  newMeshAttachment(
    _skin: spine.Skin,
    name: string,
    path: string
  ): spine.MeshAttachment {
    const region = this.findRegion(path);
    if (!region) {
      throw new Error(`Region not found in any atlas: ${path}`);
    }
    const attachment = new spine.MeshAttachment(name, path);
    attachment.region = region;
    return attachment;
  }

  newBoundingBoxAttachment(
    _skin: spine.Skin,
    name: string
  ): spine.BoundingBoxAttachment {
    return new spine.BoundingBoxAttachment(name);
  }

  newPathAttachment(_skin: spine.Skin, name: string): spine.PathAttachment {
    return new spine.PathAttachment(name);
  }

  newPointAttachment(_skin: spine.Skin, name: string): spine.PointAttachment {
    return new spine.PointAttachment(name);
  }

  newClippingAttachment(
    _skin: spine.Skin,
    name: string
  ): spine.ClippingAttachment {
    return new spine.ClippingAttachment(name);
  }
}
